import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import SvgColor from 'src/components/svg-color';

import {
  HomeIcon,
  BaccaratIcon,
  CasinoIcon,
  BlackjackIcon,
  FavoriteIcon,
  GameShowIcon,
  LiveCasinoIcon,
  RecentIcon,
  RewardIcon,
  RouletteIcon,
  SlotIcon,
  DiceIcon,
} from 'src/assets/icons/bstakes';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  notification: icon('ic_notification'),
  gift: icon('ic_gift'),
  wallet: icon('ic_wallet'),
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        // subheader: 'overview',
        items: [
          // {
          //   title: 'Home',
          //   path: paths.dashboard.root,
          //   icon: <HomeIcon />,
          //   type: 'link',
          //   text: 'home',
          // },
          // {
          //   title: 'Favorites',
          //   path: paths.dashboard.root,
          //   icon: <FavoriteIcon />,
          //   type: 'link',
          //   text: 'favorite',
          // },
          // {
          //   title: 'Recently Played',
          //   path: paths.dashboard.root,
          //   icon: <RecentIcon />,
          //   type: 'link',
          //   text: 'recent',
          // },
          // {
          //   title: 'Rewards',
          //   path: paths.dashboard.root,
          //   icon: <RewardIcon />,
          //   type: 'link',
          //   text: 'reward',
          // },
          {
            title: 'Casino',
            path: paths.dashboard.root,
            icon: <CasinoIcon />,
            children: [
              {
                title: 'Slots',
                path: paths.dashboard.root,
                icon: <SlotIcon />,
                type: 'link',
                text: 'slot',
              },
              {
                title: 'Crash Games',
                path: paths.dashboard.casino,
                icon: <DiceIcon />,
                type: 'link',
                text: 'crash_game',
              },
            ],
          },
          {
            title: 'Live Casino',
            path: paths.dashboard.root,
            icon: <LiveCasinoIcon fill="#fff" />,
            children: [
              {
                title: 'Blackjack',
                path: paths.dashboard.root,
                icon: <BlackjackIcon />,
                type: 'link',
                text: 'blackjack',
              },
              {
                title: 'Roulette',
                path: paths.dashboard.root,
                icon: <RouletteIcon />,
                type: 'link',
                text: 'roulette',
              },
              {
                title: 'Baccarat',
                path: paths.dashboard.root,
                icon: <BaccaratIcon />,
                type: 'link',
                text: 'roulette',
              },
              {
                title: 'Game Shows',
                path: paths.dashboard.root,
                icon: <GameShowIcon />,
                type: 'link',
                text: 'game_show',
              },
            ],
          },
        ],
      },
      {
        // subheader: 'Management',
        items: [
          {
            title: 'Account',
            path: '',
            icon: ICONS.user,
            type: 'button',
            text: 'account',
          },
          {
            title: 'Cashier',
            path: '',
            icon: ICONS.wallet,
            type: 'button',
            text: 'cashier',
          },
          {
            title: 'Rewards',
            path: '',
            icon: ICONS.gift,
            type: 'button',
            text: 'rewards',
          },
          {
            title: 'Notifications',
            path: '',
            icon: ICONS.notification,
            type: 'button',
            text: 'notifications',
          },
        ],
      },
    ],
    []
  );

  return data;
}

export function useLockNavData() {
  const data = useMemo(
    () => [
      {
        items: [
          {
            title: 'Casino',
            path: paths.dashboard.root,
            icon: <CasinoIcon />,
            children: [
              {
                title: 'Slots',
                path: paths.dashboard.root,
                icon: <SlotIcon />,
                type: 'link',
                text: 'slot',
              },
              {
                title: 'Crash Games',
                path: paths.dashboard.liveCasino,
                icon: <DiceIcon />,
                type: 'link',
                text: 'crash_game',
              },
            ],
          },
          {
            title: 'Live Casino',
            path: paths.dashboard.root,
            icon: <LiveCasinoIcon fill="#fff" />,
            children: [
              {
                title: 'Blackjack',
                path: paths.dashboard.root,
                icon: <BlackjackIcon />,
                type: 'link',
                text: 'blackjack',
              },
              {
                title: 'Roulette',
                path: paths.dashboard.root,
                icon: <RouletteIcon />,
                type: 'link',
                text: 'roulette',
              },
              {
                title: 'Baccarat',
                path: paths.dashboard.root,
                icon: <BaccaratIcon />,
                type: 'link',
                text: 'roulette',
              },
              {
                title: 'Game Shows',
                path: paths.dashboard.root,
                icon: <GameShowIcon />,
                type: 'link',
                text: 'game_show',
              },
            ],
          },
        ],
      },
    ],
    []
  );

  return data;
}


export function useMiniNavData() {
  const data = useMemo(
    () => [
      {
        items: [
          {
            title: 'Casino',
            path: paths.dashboard.casino,
            icon: <CasinoIcon />,
            type: 'link',
            text: 'casino',
          },
          {
            title: 'Crash Games',
            path: paths.dashboard.crashGame,
            icon: <DiceIcon />,
            type: 'link',
            text: 'crash_game',
          },
          {
            title: 'Live Casino',
            path: paths.dashboard.liveCasino,
            icon: <LiveCasinoIcon />,
            type: 'link',
            text: 'live_casino',
          },
        ],
      },
      {
        items: [
          {
            title: 'Account',
            path: '',
            icon: ICONS.user,
            type: 'button',
            text: 'account',
          },
          {
            title: 'Cashier',
            path: '',
            icon: ICONS.wallet,
            type: 'button',
            text: 'cashier',
          },
          {
            title: 'Rewards',
            path: '',
            icon: ICONS.gift,
            type: 'button',
            text: 'rewards',
          },
          {
            title: 'Notifications',
            path: '',
            icon: ICONS.notification,
            type: 'button',
            text: 'notifications',
          },
        ],
      },
    ],
    []
  );

  return data;
}

export function useLockMiniNavData() {
  const data = useMemo(
    () => [
      {
        items: [
          {
            title: 'Casino',
            path: paths.dashboard.casino,
            icon: <CasinoIcon />,
            type: 'link',
            text: 'casino',
          },
          {
            title: 'Crash Games',
            path: paths.dashboard.crashGame,
            icon: <DiceIcon />,
            type: 'link',
            text: 'crash_game',
          },
          {
            title: 'Live Casino',
            path: paths.dashboard.liveCasino,
            icon: <LiveCasinoIcon />,
            type: 'link',
            text: 'live_casino',
          },
        ],
      },
    ],
    []
  );

  return data;
}